import Keycloak from "keycloak-js";

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(
    `/keycloak_${process.env.REACT_APP_ENV_NAME}.json`
);

export default keycloak;
